import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Typography } from 'antd';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from 'recharts';
import { CAMPAIGN_TRACKING } from '../../apis/apis';
import { useNavigate, useParams } from 'react-router-dom';
import CampaignUsers from './CampaignUsers';
import { LeftOutlined, ReloadOutlined } from "@ant-design/icons";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { useLocation } from 'react-router-dom';



function ViewCampaign() {
  const { Text } = Typography;
  const location = useLocation();

  const fromPage = location.state?.page || 1;

  const fromPageSize = location.state?.pageSize || 10;

  const fromSearch = location.state?.search || "";

  const from = location.state?.from || "campaign";




  const navigate = useNavigate();
  const { id } = useParams();
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loader, setLoader] = useState(true);

  const [email_send, set_email_send] = useState('');
  const [email_open, set_email_open] = useState('');
  const [email_clicked, set_email_clicked] = useState('');
  const [data_submit, set_data_submit] = useState('');

  const [email_report, set_email_report] = useState(0);
  const [Report_Chart, set_Report_Chart] = useState([]);

  const [attachment_download, set_attachment_download] = useState(0);
  const [Download_Chart, set_Download_Chart] = useState([]);

  const [campaign_name, set_campaign_name] = useState('');
  const [smtp_name, set_smtp_name] = useState('');
  const [group_name, set_group_name] = useState('');
  const [email_template_name, set_email_template_name] = useState('');
  const [group_type, set_group_type] = useState('');

  const [Email_Sended_Chart, set_Email_Sended_Chart] = useState([]);
  const [Email_Open_Chart, set_Email_Open_Chart] = useState([]);
  const [Email_Clicked_Chart, set_Email_Clicked_Chart] = useState([]);
  const [Data_Submit_Chart, set_Data_Submit_Chart] = useState([]);

  const [filterStatus, setFilterStatus] = useState("");

  // helper: when user clicks a chart slice
  const chartClick = (status) => {
    // status expected as string like "0","1","2","3"
    setFilterStatus(status);
    setLoadingUsers(true); // show loader in parent until CampaignUsers fetch finishes and calls setLoadingUsers(false)
  };

  const handleBack = () => {
    if (from === "campaign-download") {
      navigate("/view-download-report-campaign", {
        state: {
          id: location.state?.reportId,
        },
      });
    } else if (from === "/") {
      navigate("/");
    } else {
      navigate("/campaign", {
        state: {
          page: location.state?.page || 1,
          pageSize: location.state?.pageSize || 10,
          search: location.state?.search || "",
        },
      });
    }
  };
  const loadTrackingData = async () => {
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("campaign_id", atob(id));
      const API = await CAMPAIGN_TRACKING(formData);

      if (API?.data?.status) {
        const d = API.data;
        set_email_send(d.email_send);
        set_email_open(d.email_open);
        set_email_clicked(d.email_clicked);
        set_data_submit(d.data_submit);
        set_email_report(d.email_report || 0);
        set_attachment_download(d.attachment_download || 0);

        set_campaign_name(d.campaign_name);
        set_smtp_name(d.smtp_name);
        set_group_name(d.group_name);
        set_email_template_name(d.email_template_name);
        set_group_type(d.group_type);

        set_Email_Sended_Chart([
          { name: 'Remain', value: parseInt(d.total_user) - parseInt(d.email_send) },
          { name: 'Email Sent', value: parseInt(d.email_send) }
        ]);

        set_Email_Open_Chart([
          { name: 'Remain', value: parseInt(d.total_user) - parseInt(d.email_open) },
          { name: 'Email Opened', value: parseInt(d.email_open) }
        ]);

        set_Email_Clicked_Chart([
          { name: 'Remain', value: parseInt(d.total_user) - parseInt(d.email_clicked) },
          { name: 'Email Clicked', value: parseInt(d.email_clicked) }
        ]);

        set_Data_Submit_Chart([
          { name: 'Remain', value: parseInt(d.total_user) - parseInt(d.data_submit) },
          { name: 'Data Submit', value: parseInt(d.data_submit) }
        ]);
        set_Report_Chart([
          {
            name: "Remain",
            value: parseInt(d.total_user) - parseInt(d.email_report || 0),
          },
          {
            name: "Reported",
            value: parseInt(d.email_report || 0),
          },

        ]);

        set_Download_Chart([
          { name: 'Remain', value: parseInt(d.total_user) - parseInt(d.attachment_download || 0) },
          { name: 'Downloaded', value: parseInt(d.attachment_download || 0) }
        ]);
      }
    } catch (err) {
      console.error("TRACKING API ERROR:", err);
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    loadTrackingData();
    const interval = setInterval(() => {
      loadTrackingData();
    }, 120000);

    // Cleanup
    return () => clearInterval(interval);
  }, [id]);

  if (loader) return <CulsightPageLoader />;

  return (
    <div className="lms-body">
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <h2
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span style={{ cursor: "pointer" }} onClick={handleBack}>
                <LeftOutlined />
              </span>{" "}
              Campaign - {campaign_name}
            </div>

            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={loadTrackingData}
            >
              Refresh
            </Button>
          </h2>
        </Col>
        <Col span={8}>
          <Card
            style={{
              height: "80px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <h3>Email Template:{" "}
              <Text
                ellipsis={{
                  tooltip: {
                    title: email_template_name,
                    overlayInnerStyle: {
                      backgroundColor: "#fff",
                      color: "#000",
                    },
                  },
                }}
                style={{
                  color: "#8c3add",
                  maxWidth: "180px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                {email_template_name}
              </Text>
            </h3>
          </Card>
        </Col>

        <Col span={8}>
          <Card
            style={{
              height: "80px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <h3>
              SMTP Name:{" "}
              <Text
                ellipsis={{
                  tooltip: {
                    title: smtp_name,
                    overlayInnerStyle: {
                      backgroundColor: "#fff",
                      color: "#000",
                    },
                  },
                }}
                style={{
                  color: "#8c3add",
                  maxWidth: "180px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                {smtp_name}
              </Text>
            </h3>
          </Card>
        </Col>

        <Col span={8}>
          <Card
            style={{
              height: "80px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <h3>
              Group Name:{" "}
              <Text
                ellipsis={{
                  tooltip: {
                    title: `${group_name} (${group_type === 1 ? "LMS Group" : "Local Group"})`,
                    overlayInnerStyle: {
                      backgroundColor: "#fff",
                      color: "#000",
                    },
                  },
                }}
                style={{
                  color: "#8c3add",
                  maxWidth: "180px",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                {group_name} ({group_type === 1 ? "LMS Group" : "Local Group"})
              </Text>
            </h3>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
        {/* EMAIL SENT */}
        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("1")} style={{ cursor: "pointer" }}>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={Email_Sended_Chart} innerRadius={55} outerRadius={75} dataKey="value" style={{ cursor: "pointer" }}>
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#8c3add" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <h4 style={{ textAlign: "center", color: "#8c3add" }}>Email Sent ({email_send})</h4>
          </Card>
        </Col>

        {/* EMAIL OPEN */}
        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("2")} style={{ cursor: "pointer" }}>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={Email_Open_Chart} innerRadius={55} outerRadius={75} dataKey="value" style={{ cursor: "pointer" }}>
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#1fa7a1" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <h4 style={{ textAlign: "center", color: "#1fa7a1" }}>Email Opened ({email_open})</h4>
          </Card>
        </Col>

        {/* CLICKED */}
        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("3")} style={{ cursor: "pointer", }}>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={Email_Clicked_Chart} innerRadius={55} outerRadius={75} dataKey="value" style={{ cursor: "pointer" }}>
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#eab451" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <h4 style={{ textAlign: "center", color: "#eab451" }}>Clicked Link ({email_clicked})</h4>
          </Card>
        </Col>

        {/* DATA SUBMIT */}
        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("4")} style={{ cursor: "pointer" }}>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={Data_Submit_Chart} innerRadius={55} outerRadius={75} dataKey="value" style={{ cursor: "pointer" }}>
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#b37feb" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <h4 style={{ textAlign: "center", color: "#b37feb" }}>Submitted Data ({data_submit})</h4>
          </Card>
        </Col>
        {/* REPORTED */}
        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("5")}
            style={{ cursor: "pointer" }}
          >
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie
                  data={Report_Chart}
                  innerRadius={55}
                  outerRadius={75}
                  dataKey="value"
                >
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#5B8DEF" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>

            <h4 style={{ textAlign: "center", color: "#5B8DEF" }}>
              Reported Email ({email_report})
            </h4>
          </Card>
        </Col>

        <Col flex="1">
          <Card
            className="chart-card"
            onClick={() => chartClick("6")}
            style={{ cursor: "pointer" }}
          >
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie
                  data={Download_Chart}
                  innerRadius={55}
                  outerRadius={75}
                  dataKey="value"
                >
                  <Cell fill="#f4f4f4" />
                  <Cell fill="#52c41a" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <h4 style={{ textAlign: "center", color: "#52c41a" }}>
              Downloaded ({attachment_download})
            </h4>
          </Card>
        </Col>
      </Row>

      <br />

      <CampaignUsers
        campaign_id={atob(id)}
        filterStatus={filterStatus}
        setLoadingUsers={setLoadingUsers}
      />

      {loadingUsers && <CulsightPageLoader />}
    </div>
  );
}

export default ViewCampaign;
